// extracted by mini-css-extract-plugin
export default {"header":"ModalHeader_header__qZs6g","backButton":"ModalHeader_backButton__OQ-b-","Button":"ModalHeader_Button__pNXBe"};